export default __webpack_public_path__ + "static/media/counting.b1a3dcfa.svg";